module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page-web"
  }, [(_vm.cform === 'find') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.information.content)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.cform === 'cooperation') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.information.content)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.cform === 'salon') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.information.introduction)
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f1c5ae2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pageWeb.vue
// module id = 326
// module chunks = 1